require("../base/base");
require("../vendor/frontoffice/index");

require('../../../vendor/bootstrap-select1.14.0-beta2/dist/js/bootstrap-select.min.js');
require('../../../vendor/bootstrap-select1.14.0-beta2/dist/js/i18n/defaults-fr_FR.min.js');

require('../utils/init-bootstrap-select');
require('../utils/popup');

//region moteur de recherche

window.Vue = require("vue");

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        window.event = function (event) {
            if (!(el == event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', window.event)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', window.event)
    },
});
Vue.config.silent = true;

import Localization from "../components/localization";
Vue.component("localization", Localization);

const app = new Vue({
    el: "#search-engine"
});

//endregion

$(document).ready(function () {

    $('.submitProperties').prop('disabled', false);

    $('.search-form-index').on('submit', function(e){
        e.preventDefault();

        var $this = $(this);

        var $q = '#1&p=1';
        // var $q = '?p=1';
        
        var $filters = $this.find('.form-data');

        $.each($filters, function(i, item){

            if($(item).data('select')) {

            } else {
                if($(item).val() && $(item).val() != '') {
                    var val = $(item).val();
                    if($(item).is("#price_max") ){
                        val = val.replace(/\s/g, "");

                    }
                    if($(item).is("#price_min") ){
                        val = val.replace(/\s/g, "");

                    }
                    $q += '&f'+ $(item).data('filter') +'=' + val;

 }
            }
        });
        window.location = '/biens/result' + $q;
    });

    $(".prix.ipt").on('keyup', function (e) {
        var spaced = $(this).val().toString().replace(/\s/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        $(this).val(spaced);
    });
});

const Kernel = require("../utils/Kernel");
window.Kernel = new Kernel();

window.Kernel.registerComponent('SeosConversion', require('../components/SeosConversion').default);
window.Kernel.registerComponent('GoogleRecaptcha', require('../../frontend/components/GoogleRecaptcha').default);
window.Kernel.registerComponent('RedirectToEstimator', require('../../frontend/components/RedirectToEstimator').default);

$( document ).ready(function() {
    window.Kernel.mountComponents($("html"));
});
